module.exports = __webpack_public_path__ + "img/mission2.a5dd0487.png";